/* ============================================================
   JUGGERNAUT USA — PDP IMAGE LIGHTBOX / ZOOM
   Loaded as an EXTERNAL asset (not inline) so it always executes
   under `shopify theme dev` hot-reload, which re-renders sections
   via innerHTML and therefore never runs inline <script> tags.
   No Liquid in this file — pure DOM by ID.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var mainImg        = document.getElementById('jug-main-image');
    var lightbox       = document.getElementById('jug-lightbox');
    var lightboxImg    = document.getElementById('jug-lightbox-img');
    var lightboxClose  = document.getElementById('jug-lightbox-close');
    var lightboxSpinner= document.getElementById('jug-lightbox-spinner');
    var lightboxPrev   = document.getElementById('jug-lightbox-prev');
    var lightboxNext   = document.getElementById('jug-lightbox-next');
    var lightboxCounter= document.getElementById('jug-lightbox-counter');

    if (!mainImg || !lightbox) return;

    /* Upgrade a gallery src to the highest-res version for the zoom view */
    function hiRes(src) {
      var out = src.replace(/(_\d+x\d*|\d+x)/, '');
      if (out.indexOf('?') > -1) out = out.replace(/width=\d+/, 'width=1800');
      return out;
    }

    /* Ordered image list, taken from the thumbnails (falls back to the single main image) */
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.jug-gallery__thumb'));
    var images = thumbs.length
      ? thumbs.map(function (t) { return { src: hiRes(t.dataset.img), alt: t.dataset.alt || mainImg.alt || '' }; })
      : [{ src: hiRes(mainImg.src), alt: mainImg.alt || '' }];
    var currentIndex = 0;

    function showImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentIndex = index;
      var item = images[index];
      resetZoom();
      if (lightboxCounter) lightboxCounter.textContent = (index + 1) + ' / ' + images.length;

      /* Hide the current image FIRST so the old one never flashes during the swap */
      lightboxImg.classList.add('loading');
      if (lightboxSpinner) lightboxSpinner.classList.remove('hidden');

      function reveal() {
        lightboxImg.classList.remove('loading');
        if (lightboxSpinner) lightboxSpinner.classList.add('hidden');
      }
      /* Reveal only once the NEW image has loaded into THIS element (next frame,
         so it's actually painted) — this is what fixes the old-image flash. */
      lightboxImg.onload = function () { requestAnimationFrame(reveal); };
      lightboxImg.onerror = reveal;
      lightboxImg.alt = item.alt || 'Enlarged product image';
      /* The global "fix missing alt" script stamps aria-hidden="true" (and the
         auto-inert script then adds `inert`) on this img while its alt was empty,
         which sets pointer-events:none and swallows zoom clicks. Strip both. */
      lightboxImg.removeAttribute('aria-hidden');
      lightboxImg.removeAttribute('inert');
      lightboxImg.src = item.src;
      /* Cached images may not fire onload — reveal immediately if already complete */
      if (lightboxImg.complete && lightboxImg.naturalWidth > 0) requestAnimationFrame(reveal);
    }

    function openLightbox(index) {
      lightbox.classList.toggle('jug-lightbox--single', images.length < 2);
      lightbox.classList.add('active');
      lightbox.setAttribute('aria-hidden', 'false');
      /* Strip any stray `inert` (the global auto-inert a11y script marks the lightbox
         inert while it's hidden) so the image is clickable/zoomable once open. */
      lightbox.removeAttribute('inert');
      lightbox.querySelectorAll('[inert]').forEach(function (el) { el.removeAttribute('inert'); });
      lightboxImg.removeAttribute('aria-hidden');
      lightboxImg.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      showImage(index);
    }

    function closeLightbox() {
      lightbox.classList.remove('active');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lightboxImg.classList.remove('loading');
      resetZoom();
      if (lightboxSpinner) lightboxSpinner.classList.add('hidden');
    }

    /* Click-to-zoom: click toggles a 2x zoom; while zoomed, move the mouse to pan; click again to zoom out. */
    var lbWrap = lightbox.querySelector('.jug-lightbox__wrap');
    function panZoom(e) {
      var pt = (e.touches && e.touches[0]) ? e.touches[0] : e;
      if (pt == null || pt.clientX == null) return;
      var r = (lbWrap || lightboxImg).getBoundingClientRect();
      var x = Math.max(0, Math.min(100, (pt.clientX - r.left) / r.width * 100));
      var y = Math.max(0, Math.min(100, (pt.clientY - r.top) / r.height * 100));
      lightboxImg.style.transformOrigin = x + '% ' + y + '%';
    }
    function onTouchPan(e) { if (e.cancelable) e.preventDefault(); panZoom(e); }
    function resetZoom() {
      lightboxImg.classList.remove('zoomed');
      /* Keep the current transform-origin so the image shrinks smoothly back to
         the same anchor it grew from (clearing it mid-transition causes a jump).
         At scale(1) the origin is visually irrelevant; the next zoom-in sets a
         fresh origin via panZoom before re-adding .zoomed. */
      lightbox.removeEventListener('mousemove', panZoom);
      lightbox.removeEventListener('touchmove', onTouchPan);
    }
    lightboxImg.addEventListener('click', function (e) {
      e.stopPropagation();
      if (lightboxImg.classList.contains('zoomed')) {
        resetZoom();
      } else {
        panZoom(e);
        lightboxImg.classList.add('zoomed');
        lightbox.addEventListener('mousemove', panZoom);
        lightbox.addEventListener('touchmove', onTouchPan, { passive: false });
      }
    });

    mainImg.addEventListener('click', function () {
      /* Open at whichever image the gallery is currently showing */
      var activeThumb = document.querySelector('.jug-gallery__thumb.active');
      var startIndex = activeThumb ? thumbs.indexOf(activeThumb) : 0;
      openLightbox(startIndex < 0 ? 0 : startIndex);
    });

    if (lightboxPrev) lightboxPrev.addEventListener('click', function (e) { e.stopPropagation(); showImage(currentIndex - 1); });
    if (lightboxNext) lightboxNext.addEventListener('click', function (e) { e.stopPropagation(); showImage(currentIndex + 1); });
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    var backdrop = lightbox.querySelector('.jug-lightbox__backdrop');
    if (backdrop) backdrop.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('active')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      else if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });

    /* Touch swipe left/right to change images */
    var touchStartX = null;
    lightbox.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      if (touchStartX === null || images.length < 2 || lightboxImg.classList.contains('zoomed')) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) showImage(currentIndex + (dx < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
